module.exports = __webpack_public_path__ + "static/media/car-door.ba96df2a.svg";